import React, { useEffect, useState } from "react";
import { Table } from "antd";
import type { TableProps } from "antd";
import useTranslation from "utils/hooks/useTranslation";

interface IRenderTable {
  columnsTable: Array<any>;
  children?: React.ReactNode;
  items: Array<any>;
  totalItems: number;
  handleTableChange: (...args) => void;
  pageIndex: number;
  isLoadingTable: boolean;
  expandable?: TableProps<any>["expandable"];
}

const RenderTable = ({ columnsTable, items, totalItems, handleTableChange, pageIndex, isLoadingTable, expandable }: IRenderTable): JSX.Element => {
  const [scrollX, setScrollX] = useState(false);

  const SHOWING = useTranslation({ id: "showing" });
  const OF = useTranslation({ id: "of" });
  const REGISTERS = useTranslation({ id: "registers" });

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1600) {
        setScrollX(true);
      } else {
        setScrollX(false);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ width: "100%", overflowX: scrollX ? "auto" : "visible" }}>
      <Table
        columns={[...columnsTable]}
        dataSource={items}
        rowKey="id"
        pagination={{
          current: pageIndex,
          total: totalItems,
          pageSizeOptions: ["10", "20", "50", "100"],
          defaultPageSize: 10,
          showSizeChanger: true,
          defaultCurrent: pageIndex,
          showTotal: (total, range) => `${SHOWING} ${range[0]}-${range[1]} ${OF} ${total} ${REGISTERS}`,
        }}
        loading={isLoadingTable}
        onChange={handleTableChange}
        style={{ whiteSpace: "pre-wrap" }}
        scroll={scrollX ? { x: "max-content" } : undefined}
        expandable={expandable}
      />
    </div>
  );
};

export default RenderTable;
